import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { API } from '../../config/api/index';

const {
  getProducts,
  getProductsError,
  getProductsBegin,
  createProducts,
  createProductsBegin,
  createProductsError,
  getCategories,
  getCategoriesError,
  getCategoriesBegin,
  getOptions,
  getOptionsError,
  getOptionsBegin,
  createOption,
  createOptionBegin,
  createOptionError,
  updateOption,
  updateOptionBegin,
  updateOptionError,
  deleteOption,
  deleteOptionBegin,
  deleteOptionError,
  getSelections,
  getSelectionsBegin,
  getSelectionsError,
  createSelection,
  createSelectionBegin,
  createSelectionError,
  updateSelection,
  updateSelectionBegin,
  updateSelectionError,
  deleteSelection,
  deleteSelectionBegin,
  deleteSelectionError,
} = actions;

const fetchProducts = params => {
  return async dispatch => {
    try {
      const { page = 1, limit = 10, searchName = '' } = params || {};
      dispatch(getProductsBegin());
      let url = `${API.pos.products}/?page=${page}&limit=${limit}`;
      if (searchName) {
        url += `&name=${encodeURIComponent(searchName)}`;
      }
      const response = await DataService.get(url);
      return dispatch(getProducts(response.data));
    } catch (err) {
      return dispatch(getProductsError(err?.message || 'Error al intentar obtener lista de productos.'));
    }
  };
};

const createProduct = params => {
  return async dispatch => {
    try {
      dispatch(createProductsBegin());
      await DataService.post(`${API.pos.products}/`, {
        name: params.name,
        price: params.price,
        category: params.category,
        options: params.options,
      });
      message.success('Producto creado con éxito');
      dispatch(createProducts());
      dispatch(fetchProducts());
    } catch (err) {
      return dispatch(createProductsError(err?.message || 'Error al intentar crear el producto'));
    }
  };
};

const updateProduct = params => {
  return async dispatch => {
    try {
      dispatch(createProductsBegin());
      await DataService.patch(`${API.pos.products}/${params.idToUpdate}`, {
        name: params.name,
        price: params.price,
        category: params.category.id,
        options: params.options,
      });
      message.success('Producto actualizado correctamente');
      dispatch(createProducts());
      dispatch(fetchProducts());
    } catch (err) {
      return dispatch(createProductsError(err?.message || 'Error al intentar actualizar el producto'));
    }
  };
};

const fetchCategories = () => {
  return async dispatch => {
    try {
      dispatch(getCategoriesBegin());
      const response = await DataService.get(`${API.pos.categories}`);
      return dispatch(getCategories(response.data.results));
    } catch (err) {
      return dispatch(getCategoriesError(err?.message || 'Error al intentar obtener categorías'));
    }
  };
};

const fetchOptions = params => {
  return async dispatch => {
    try {
      const { searchName = '' } = params || {};
      dispatch(getOptionsBegin());
      let url = `${API.pos.options}`;
      if (searchName) {
        url += `?name=${encodeURIComponent(searchName)}`;
      }
      const response = await DataService.get(url);
      return dispatch(getOptions(response.data));
    } catch (err) {
      return dispatch(getOptionsError(err?.message || 'Error al intentar obtener las opciones'));
    }
  };
};

const createOptionAction = params => {
  return async dispatch => {
    try {
      dispatch(createOptionBegin());
      await DataService.post(`${API.pos.options}/`, {
        name: params.name,
        type: params.type,
        selectionsData: params.selectionsData,
        mandatory: params.mandatory,
      });
      message.success('Opción creada con éxito');
      dispatch(createOption());
      dispatch(fetchOptions());
    } catch (err) {
      message.error(err?.message || 'Error al intentar crear la opción');
      return dispatch(createOptionError(err?.message || 'Error al intentar crear la opción'));
    }
  };
};

const updateOptionAction = params => {
  return async dispatch => {
    try {
      dispatch(updateOptionBegin());
      await DataService.patch(`${API.pos.options}/${params.id}`, {
        name: params.name,
        type: params.type,
        selectionsData: params.selectionsData,
        mandatory: params.mandatory,
      });
      message.success('Opción actualizada correctamente');
      dispatch(updateOption(params));
      dispatch(fetchOptions());
    } catch (err) {
      message.error(err?.message || 'Error al intentar actualizar la opción');
      return dispatch(updateOptionError(err?.message || 'Error al intentar actualizar la opción'));
    }
  };
};

const deleteOptionAction = id => {
  return async dispatch => {
    try {
      dispatch(deleteOptionBegin());
      await DataService.delete(`${API.pos.options}/${id}`);
      message.success('Opción eliminada correctamente');
      dispatch(deleteOption(id));
      dispatch(fetchOptions());
    } catch (err) {
      message.error(err?.message || 'Error al intentar eliminar la opción');
      return dispatch(deleteOptionError(err?.message || 'Error al intentar eliminar la opción'));
    }
  };
};

// Selection actions
const fetchSelections = () => {
  return async dispatch => {
    try {
      dispatch(getSelectionsBegin());
      const response = await DataService.get(`${API.pos.selections}`);
      return dispatch(getSelections(response.data));
    } catch (err) {
      return dispatch(getSelectionsError(err?.message || 'Error al intentar obtener las selecciones'));
    }
  };
};

const createSelectionAction = params => {
  return async dispatch => {
    try {
      dispatch(createSelectionBegin());
      const response = await DataService.post(`${API.pos.selections}/`, {
        title: params.title,
        extraPrice: params.extraPrice || 0,
      });
      message.success('Selección creada con éxito');
      dispatch(createSelection(response.data));
      dispatch(fetchSelections());
      return response.data;
    } catch (err) {
      message.error(err?.message || 'Error al intentar crear la selección');
      return dispatch(createSelectionError(err?.message || 'Error al intentar crear la selección'));
    }
  };
};

const updateSelectionAction = params => {
  return async dispatch => {
    try {
      dispatch(updateSelectionBegin());
      await DataService.patch(`${API.pos.selections}/${params.id}`, {
        title: params.title,
        extraPrice: params.extraPrice,
      });
      message.success('Selección actualizada correctamente');
      dispatch(updateSelection(params));
      dispatch(fetchSelections());
    } catch (err) {
      message.error(err?.message || 'Error al intentar actualizar la selección');
      return dispatch(updateSelectionError(err?.message || 'Error al intentar actualizar la selección'));
    }
  };
};

const deleteSelectionAction = id => {
  return async dispatch => {
    try {
      dispatch(deleteSelectionBegin());
      await DataService.delete(`${API.pos.selections}/${id}`);
      message.success('Selección eliminada correctamente');
      dispatch(deleteSelection(id));
      dispatch(fetchSelections());
    } catch (err) {
      message.error(err?.message || 'Error al intentar eliminar la selección');
      return dispatch(deleteSelectionError(err?.message || 'Error al intentar eliminar la selección'));
    }
  };
};

export {
  fetchProducts,
  createProduct,
  updateProduct,
  fetchCategories,
  fetchOptions,
  createOptionAction,
  updateOptionAction,
  deleteOptionAction,
  fetchSelections,
  createSelectionAction,
  updateSelectionAction,
  deleteSelectionAction,
};
